export default __webpack_public_path__ + "static/banner_back-2313bce3fe844171dce3247751832fc1.webp";